import styled from "styled-components";
import { Paper, Box } from "@mui/material";

export const PageWrapper = styled(Box)`
  padding: 1px;
  /* max-width: 1400px; */
  height: 80vh;
  margin: 0 auto;
  font-family: "Nunito", sans-serif;
`;

export const TwoColumnLayout = styled(Box)`
  display: flex;
  gap: 24px;
  align-items: flex-start;
  flex-wrap: wrap;

  @media (min-width: 960px) {
    flex-wrap: nowrap;
  }
`;

export const FormColumn = styled(Box)`
  flex: 0 0 auto;
  width: 100%;
  min-width: 0;

  @media (min-width: 960px) {
    width: 420px;
    max-width: 420px;
  }
`;

export const ResultsColumn = styled(Box)`
  flex: 1 1 400px;
  min-width: 0;
`;

export const ResultsPlaceholder = styled(Box)`
  padding: 32px 24px;
  text-align: center;
  font-size: 14px;
  color: #888;
  background: ${({ theme }) => theme.colors?.bg?.mainLightBg || "#F6F6F9"};
  border-radius: 10px;
  border: 1px dashed ${({ theme }) => theme.colors?.border?.grey || "rgba(49, 57, 73, 0.15)"};
`;

export const PageTitle = styled.h2`
  margin: 0 0 24px 0;
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors?.text?.lightBlack || "#313949"};
  letter-spacing: -0.02em;
`;

export const FormCard = styled(Paper)`
  padding: 24px 24px 28px;
  background: ${({ theme }) => theme.colors?.bg?.whiteBg || "#ffffff"} !important;
  border-radius: 10px !important;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.03) !important;
  border: 1px solid ${({ theme }) => theme.colors?.border?.grey || "rgba(49, 57, 73, 0.08)"};
`;

export const SectionTitle = styled.h3`
  margin: 0 0 12px 0;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors?.text?.lightBlack || "#313949"};
`;

export const SectionDivider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.colors?.border?.grey || "#f0f0f0"};
  margin: 20px 0 24px 0;
`;

export const DryRunBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
  padding: 16px;
  margin-top: 8px;
  background: ${({ theme }) => theme.colors?.bg?.mainLightBg || "#F6F6F9"};
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors?.border?.grey || "rgba(49, 57, 73, 0.08)"};
`;

export const ResultsCard = styled(Paper)`
  padding: 24px 24px 28px;
  background: ${({ theme }) => theme.colors?.bg?.whiteBg || "#ffffff"} !important;
  border-radius: 10px !important;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.03) !important;
  border: 1px solid ${({ theme }) => theme.colors?.border?.grey || "rgba(49, 57, 73, 0.08)"};
  min-height: 200px;
`;

export const ResultTableWrapper = styled.div`
  overflow-x: auto;
  margin-top: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors?.border?.grey || "rgba(49, 57, 73, 0.1)"};
  min-height: 120px;
  background: ${({ theme }) => theme.colors?.bg?.whiteBg || "#fff"};

  .MuiTable-root {
    font-family: "Nunito", sans-serif;
    min-width: 400px;
  }
  .MuiTableContainer-root {
    min-height: 80px;
  }
  .MuiTableHead-root .MuiTableCell-head {
    font-weight: 600;
    font-size: 13px;
    color: ${({ theme }) => theme.colors?.text?.lightBlack || "#313949"};
    background: ${({ theme }) => theme.colors?.bg?.mainLightBg || "#F6F6F9"};
    border-bottom: 1px solid ${({ theme }) => theme.colors?.border?.grey || "rgba(49, 57, 73, 0.1)"};
    padding: 12px 16px;
  }
  .MuiTableBody-root .MuiTableCell-body {
    font-size: 14px;
    color: ${({ theme }) => theme.colors?.color?.lightBlack || "#333"};
    padding: 10px 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors?.border?.grey || "rgba(49, 57, 73, 0.06)"};
  }
  .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-body {
    border-bottom: none;
  }
`;
